import Handler from "../Handler";

class SendEmojiFailureHandler extends Handler {
  execute(data) {
    let receivedData = JSON.parse(data);
    this.service.processEmojiFailure(receivedData);
  }
}

export default SendEmojiFailureHandler;
// sendEmojiF#{playerName: "prime897379", tableId: "THR3J-3nnIw6G", statusCode: 106}
